import { render, staticRenderFns } from "./resumenLibrosObsequios.vue?vue&type=template&id=2e831082"
import script from "./resumenLibrosObsequios.vue?vue&type=script&lang=js"
export * from "./resumenLibrosObsequios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports